import React from "react";
import { Trophy, Layers, Zap } from "lucide-react";
import "./SinglePlayerGame.css";

interface ScorePaneProps {
  score: number;
  level: number;
  lines: number;
}

export function ScorePane({ score, level, lines }: ScorePaneProps) {
  return (
    <div className="score-pane">
      <div className="score-pane-card">
        <div className="score-pane-accent" />
        <div className="score-pane-grid">
          <div className="score-pane-section score-pane-score">
            <div className="score-pane-hover-veil score-pane-score-veil" />
            <div className="score-pane-label score-pane-score-label">
              <Trophy className="score-pane-icon" />
              <span>Score</span>
            </div>
            <div className="score-pane-value score-pane-score-value">
              {score.toLocaleString()}
            </div>
          </div>
          <div className="score-pane-section score-pane-level">
            <div className="score-pane-hover-veil score-pane-level-veil" />
            <div className="score-pane-label score-pane-level-label">
              <Zap className="score-pane-icon" />
              <span>Level</span>
            </div>
            <div className="score-pane-value score-pane-level-value">
              {level}
            </div>
          </div>
          <div className="score-pane-section score-pane-lines">
            <div className="score-pane-hover-veil score-pane-lines-veil" />
            <div className="score-pane-label score-pane-lines-label">
              <Layers className="score-pane-icon" />
              <span>Lines</span>
            </div>
            <div className="score-pane-value score-pane-lines-value">
              {lines}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

